import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_NETWORK_ATTACK_TECHNIQUES,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { NetworkAttackWebComponent } from '../../../../networkAttackTechniques';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  BlockedNetworkAttackTechniquesPayload, GetBlockedNetworkAttackTechniquesResponse,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_NETWORK_ATTACK_TECHNIQUES)
export class GzNetworkAttackWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: BlockedNetworkAttackTechniquesPayload;

  @query('#gzNetworkAttackTechniques')
  private networkAttackTechniques: NetworkAttackWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getBlockedNetworkAttackTechniques: function (request: GetWidgetDataRequest): Observable<GetBlockedNetworkAttackTechniquesResponse> {
              return of(this.getPayload().blockedNetworkAttackTechniques);
            }.bind(this)
          }
        }
      }
    };

    if (this.networkAttackTechniques) {
      if (!this.networkAttackTechniques.started) {
        this.networkAttackTechniques.injectDependencies(dependencies);
        this.networkAttackTechniques.start();
      } else {
        this.networkAttackTechniques.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-network-attack-techniques id="gzNetworkAttackTechniques"
                                    data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                                    data-targets=${JSON.stringify(this.payload?.targets)}
                                    data-can-drill-down=${true}
                                    data-display-mode=${getDisplayMode()}
      ></gz-network-attack-techniques>`;
  }
}
